import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NumericRangeDirective, FormatDecimalDirective } from './numeric.directive';
import { ReaisDirective } from './reais.directive';
import { PorcentagemDirective } from './porcentagem.directive';

@NgModule({
    declarations: [
        NumericRangeDirective,
        FormatDecimalDirective,
        ReaisDirective,
        PorcentagemDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        NumericRangeDirective,
        FormatDecimalDirective,
        ReaisDirective,
        PorcentagemDirective
    ]
})
export class DirectivesModule { }
